import { ApiResponse, Config, ConfigMutate } from "./types";
import {
  transformConfigToBody,
  transformConfigToQuery,
  userMessage,
} from "./utils";

const BASE_URL = "/api";

export async function client<ApiEntity, ApiEntityExtraFields = {}>(
  endpoint: string,
  { method, ...customConfig }: RequestInit = {}
): Promise<ApiResponse<ApiEntity & ApiEntityExtraFields> | undefined> {
  const headers: HeadersInit = { "content-type": "application/json" };

  const config: RequestInit = {
    credentials: "include",
    method: method ?? "GET",
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  const response = await fetch(`${BASE_URL}/${endpoint}`, config);
  if (response.status === 401) {
    logout();
    return;
  }

  const jsonResponse = await response.json();

  if (!response.ok) {
    return Promise.reject({
      message: userMessage({
        method: config.method,
        errorMsgNoun: endpoint,
      }),
      response: { data: jsonResponse, status: response.status },
    });
  }

  return jsonResponse;
}

function isConfigMutate<ApiEntity, ApiEntityExtraFields>(
  config:
    | Config<ApiEntity, ApiEntityExtraFields>
    | ConfigMutate<ApiEntity, ApiEntityExtraFields>
    | undefined
): config is ConfigMutate<ApiEntity, ApiEntityExtraFields> {
  if ((config as ConfigMutate<any, any>).data) {
    return true;
  }
  return false;
}

export const api = {
  get: <ApiEntity, ApiEntityExtraFields = []>(
    endpoint: string,
    config?: Config<ApiEntity, ApiEntityExtraFields>
  ) => {
    const query = transformConfigToQuery(config);
    // Potencjał na usprawnienie: Uzależnienie zwracanego typu od tego czy w `config` był podany dany `extra_field`.
    return client<ApiEntity, ApiEntityExtraFields>(`${endpoint}?${query}`, {
      method: "GET",
    });
  },
  create: <ApiEntity, ApiEntityExtraFields>(
    endpoint: string,
    config?: ConfigMutate<ApiEntity, ApiEntityExtraFields>
  ) => {
    const body = transformConfigToBody(config);
    return client<ApiEntity, ApiEntityExtraFields>(endpoint, {
      method: "POST",
      body,
    });
  },
  update: <ApiEntity, ApiEntityExtraFields>(
    endpoint: string,
    config?: ConfigMutate<ApiEntity, ApiEntityExtraFields>
  ) => {
    const body = transformConfigToBody(config);
    return client<ApiEntity, ApiEntityExtraFields>(endpoint, {
      method: "PATCH",
      body,
    });
  },
  remove: <ApiEntity, ApiEntityExtraFields>(endpoint: string) =>
    client<ApiEntity, ApiEntityExtraFields>(endpoint, {
      method: "DELETE",
    }),
};

function logout() {
  window.location.assign("/security/login");
}
